import {
  Injectable
} from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import {
  Observable
} from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {
  userState = localStorage.getItem('stateUser');
  userKey = localStorage.getItem('key');

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable < boolean > | Promise < boolean > | boolean {
    if (localStorage.getItem('stateUser') && localStorage.getItem('key')){
      return true;
    }
    this.router.navigateByUrl('/login');
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guard/auth.guard.ts